import { ComponentStyleConfig } from '@chakra-ui/react';

export const Box: ComponentStyleConfig = {
    baseStyle: {
        borderRadius: 0
    }
};
